import {
  ApartmentOutlined,
  BookOutlined,
  ContainerOutlined,
  DatabaseOutlined,
  DeploymentUnitOutlined,
  FileDoneOutlined,
  FileTextOutlined,
  GiftOutlined,
  GroupOutlined,
  LineChartOutlined,
  SafetyCertificateOutlined,
  SendOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  SolutionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import i18n from "translations/i18n";
import urls from "urls";
import { PERMISSIONS } from "../functions/permissions";

const shopNavTree = [
  {
    key: "sales",
    title: i18n.t("sales"),
    breadcrumb: false,
    submenu: [
      {
        key: "shop-reports",
        permission: PERMISSIONS.REPORTS_VIEW,
        path: urls.reports,
        title: i18n.t("reports"),
        icon: LineChartOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-reports-general",
            permission: PERMISSIONS.REPORTS_VIEW,
            path: urls.reportsGeneral,
            title: i18n.t("general"),
            icon: "",
            submenu: [],
          },
          {
            key: "shop-reports-products",
            permission: PERMISSIONS.REPORTS_VIEW,
            path: urls.reportsProducts,
            title: i18n.t("products"),
            icon: "",
            submenu: [],
          },
          {
            key: "shop-reports-sellers",
            permission: PERMISSIONS.REPORTS_VIEW,
            path: urls.reportsSellers,
            title: i18n.t("sellers"),
            icon: "",
            submenu: [],
          },
        ],
      },
      {
        key: "shop-products",
        permission: PERMISSIONS.PRODUCTS_MANAGE,
        title: i18n.t("products"),
        icon: ShoppingCartOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-products-productList",
            permission: PERMISSIONS.PRODUCTS_MANAGE,
            path: urls.productList,
            title: i18n.t("products"),
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "shop-products-productEvents",
            permission: PERMISSIONS.PRODUCTS_MANAGE,
            path: urls.productEvents,
            title: i18n.t("product_events"),
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "shop-products-priceImport",
            permission: PERMISSIONS.PRODUCTS_MANAGE,
            path: urls.productPriceImport,
            title: i18n.t("price_import.nav"),
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "shop-products-attributes",
            permission: PERMISSIONS.PRODUCTS_MANAGE,
            path: urls.productAttributes,
            title: i18n.t("product_attributes"),
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-categories",
        permission: PERMISSIONS.CATEGORIES_MANAGE,
        path: urls.categories,
        title: i18n.t("categories"),
        icon: GroupOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-discounts",
        permission: PERMISSIONS.DISCOUNTS_MANAGE,
        title: i18n.t("discounts"),
        icon: GiftOutlined,
        breadcrumb: false,
        submenu: [
          // {
          //   key: "shop-discounts-promotions",
          //   path: urls.promotions,
          //   title: i18n.t("promotions"),
          //   icon: "",
          //   breadcrumb: true,
          //   submenu: [],
          // },
          {
            key: "shop-discounts-discountCode",
            permission: PERMISSIONS.DISCOUNTS_MANAGE,
            path: urls.discountCodes,
            title: i18n.t("discount_codes"),
            icon: "",
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-orders",
        permission: PERMISSIONS.ORDERS_VIEW,
        title: i18n.t("order.orders"),
        icon: FileTextOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-orders-all",
            permission: PERMISSIONS.ORDERS_VIEW,
            path: urls.ordersList,
            title: i18n.t("order.orders"),
            icon: "",
            submenu: [],
          },
          {
            key: "shop-orders-exact",
            permission: PERMISSIONS.ORDERS_EXACT,
            path: urls.exactOrdersList,
            title: i18n.t("order.exact"),
            icon: "",
            submenu: [],
          },
        ],
      },
      {
        key: "shop-shipments",
        permission: PERMISSIONS.SHIPMENTS_MANAGE,
        path: urls.shipmentsList,
        title: i18n.t("shipment.shipments"),
        icon: SendOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "shop-customers",
        permission: PERMISSIONS.CUSTOMERS_VIEW,
        title: i18n.t("customers"),
        icon: SolutionOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "shop-customers-existing",
            permission: PERMISSIONS.CUSTOMERS_VIEW,
            path: urls.customerList,
            title: i18n.t("customers_all"),
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-customers-pending",
            permission: PERMISSIONS.CUSTOMERS_PENDING,
            path: urls.customerListPending,
            title: i18n.t("customers_pending"),
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-customers-audiences",
            permission: PERMISSIONS.CUSTOMERS_AUDIENCES,
            path: urls.audiences,
            title: i18n.t("audiences"),
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "shop-customers-map",
            permission: PERMISSIONS.CUSTOMERS_MAP,
            path: urls.customerMap,
            title: i18n.t("customer_map"),
            icon: "",
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "shop-dealers",
        permission: PERMISSIONS.DEALERS_MANAGE,
        title: i18n.t("dealers"),
        path: urls.dealers,
        icon: DeploymentUnitOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

// De zes inkooppagina's stonden genest onder één submenu "Inkooporders" binnen de
// groep "Inkoop" — Verzendingen of Facturen openen kostte daardoor twee klikken,
// en de tussenlaag droeg dezelfde naam als de pagina eronder. Het ontwerp zet ze
// als losse items direct onder de groep; dat is één klik en één label minder.
const purchasingNavTree = [
  {
    key: "purchasing",
    title: i18n.t("purchasing"),
    breadcrumb: false,
    submenu: [
      {
        key: "purchasing-purchase-orders-all",
        permission: PERMISSIONS.PURCHASING_MANAGE,
        path: urls.purchaseOrdersList,
        title: i18n.t("order.purchase_orders"),
        icon: SolutionOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "purchasing-shipments",
        permission: PERMISSIONS.PURCHASING_MANAGE,
        path: urls.purchaseOrderShipmentsList,
        title: i18n.t("purchase_order_shipments"),
        icon: ContainerOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "purchasing-invoices",
        permission: PERMISSIONS.PURCHASING_MANAGE,
        path: urls.purchaseOrderInvoicesList,
        title: i18n.t("purchase_order_invoices"),
        icon: FileDoneOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "purchasing-stock",
        permission: PERMISSIONS.PURCHASING_MANAGE,
        path: urls.stockOverview,
        title: i18n.t("stock_overview"),
        icon: DatabaseOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "purchasing-suppliers",
        permission: PERMISSIONS.PURCHASING_MANAGE,
        path: urls.suppliersList,
        title: i18n.t("order.suppliers"),
        icon: ShopOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "purchasing-product-drafts",
        permission: PERMISSIONS.PURCHASING_MANAGE,
        path: urls.productDraftsList,
        title: i18n.t("product_drafts"),
        icon: FileTextOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const adminNavTree = [
  {
    key: "admin",
    title: i18n.t("admin"),
    breadcrumb: false,
    submenu: [
      {
        key: "admin-collections",
        permission: PERMISSIONS.ADMIN_COLLECTIONS,
        path: urls.collections,
        title: i18n.t("collections"),
        icon: ApartmentOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "admin-groups",
        permission: PERMISSIONS.ADMIN_GROUPS,
        path: urls.groups,
        title: i18n.t("groups"),
        icon: GroupOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "admin-users",
        permission: PERMISSIONS.ADMIN_USERS,
        path: urls.users,
        title: i18n.t("users"),
        icon: UserOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "admin-roles",
        permission: PERMISSIONS.ADMIN_USERS,
        path: urls.roles,
        title: i18n.t("roles.title"),
        icon: SafetyCertificateOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "purchasing-documentation",
        permission: PERMISSIONS.ADMIN_DOCUMENTATION,
        path: urls.documentation,
        title: i18n.t("documentation"),
        icon: BookOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
];

// Elk item met een `path` draagt een `permission` (functions/permissions.js).
// MenuContent verbergt items zonder permissie, RequirePermission bewaakt de
// route zelf. Een groep zonder zichtbare items verdwijnt vanzelf. Voorheen was
// er alleen `isAdmin: true` op de beheer-groep; dat is opgegaan in ADMIN_*.
const navigationConfig = [...shopNavTree, ...purchasingNavTree, ...adminNavTree];

/** Alle items met een pad, in menuvolgorde (diepte-eerst). */
export const flattenNavigation = (tree = navigationConfig) =>
  tree.flatMap((item) => [
    ...(item.path ? [item] : []),
    ...(item.submenu && item.submenu.length > 0 ? flattenNavigation(item.submenu) : []),
  ]);

/**
 * Startpagina voor een gebruiker. `can` komt uit usePermissions.
 * - Wie orders beheert (admin, gebruiker) landt op de orderlijst — dat was
 *   altijd al het vaste startpunt.
 * - Wie dat niet mag maar wel klanten ziet (verkoper) landt op de klantenlijst.
 * - Anders het eerste menu-item dat hij mag zien; valt terug op de orderlijst,
 *   waar RequirePermission dan de 403-pagina toont.
 */
export const getDefaultPath = (can) => {
  const allowed = (item) => !item.permission || (typeof can === "function" && can(item.permission));
  const preferred = [
    { path: urls.ordersList, permission: PERMISSIONS.ORDERS_MANAGE },
    { path: urls.customerList, permission: PERMISSIONS.CUSTOMERS_VIEW },
  ];
  const first = [...preferred, ...flattenNavigation()].find(allowed);
  return first ? first.path : urls.ordersList;
};

export default navigationConfig;
